import { Box, VStack, SimpleGrid } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

const Footer = () =>
(
    <Box bg="#232A34" py="20px">
        <VStack w="100%" align="center" my="20px" spacing="0px">
            <Text fontFamily="Museo Sans" fontSize="sm" color="white">powered by Shaka Crossfit</Text>
            <Text fontFamily="Museo Sans" fontSize="sm" color="white">© 2021 Alrights reserved</Text>
            <a href="https://shakacrossfit.com" target="_blank" style={{ textDecoration: 'none' }} rel="noopener noreferrer">
                <Text mt="10px" fontFamily="Dead Stock" fontSize="2xl" color="#00E6FF">
                    SHAKA
                </Text>
            </a>
        </VStack>
        <SimpleGrid mt="60px" mb="40px" columns={{sm: 1, md: 2, xl: 4}} spacing="40px">
            <Box color="white" textAlign="center" fontFamily="Museo Sans">
                <Text fontFamily="Museo Sans Bold" fontSize="xl">VISÍTANOS</Text>
                <a href="https://goo.gl/maps/sKyYJZz7jEA4xvk8A" target="_blank" rel="noopener noreferrer">
                <Text mt={4}>Paseo de los Melancólicos, 11, 28005 Madrid</Text>
                </a>
            </Box>
            <Box color="white" textAlign="center" fontFamily="Museo Sans">
                <Text fontFamily="Museo Sans Bold" fontSize="xl">LLÁMANOS</Text>
                <Text mt={4}>+34 675967155</Text>
            </Box>
            <Box color="white" textAlign="center" fontFamily="Museo Sans">
                <Text fontFamily="Museo Sans Bold" fontSize="xl">ENCUÉNTRANOS</Text>
                <a href="https://www.shakacrossfit.com/blog/" target="_blank" rel="noopener noreferrer">
                <Text mt={4}>Blog</Text>
                </a>
                <a href="https://www.instagram.com/shakacrossfit/" target="_blank" style={{ textDecorationColor: '#FFFFFF' }} rel="noopener noreferrer">
                <FontAwesomeIcon icon={ faInstagram } style={{ fontSize: '30px', color: '#FFFFFF' }} /><br/>
              </a>
            </Box>
            <Box color="white" textAlign="center" fontFamily="Museo Sans">
                <Text fontFamily="Museo Sans Bold" fontSize="xl">+ INFO</Text>
                <a href="https://www.shakacrossfit.com/tarifas/" target="_blank" rel="noopener noreferrer">
                <Text mt={4}>Tarifas</Text>
                </a>
                <a href="https://www.shakacrossfit.com/clases/" target="_blank" rel="noopener noreferrer">
                <Text>Clases</Text>
                </a>
                <a href="https://www.shakacrossfit.com/horarios/" target="_blank" rel="noopener noreferrer">
                <Text>Horarios</Text>
                </a>
            </Box>
        </SimpleGrid>
    </Box>
);

export default Footer;